import { computed, ref, watchEffect } from 'vue';

const STORAGE_KEY = 'kx-theme';
type Mode = 'light' | 'dark' | 'system';

const mode = ref<Mode>(readStored());

function readStored(): Mode {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v === 'light' || v === 'dark' ? v : 'system';
  } catch {
    return 'system';
  }
}

const systemDark = ref(window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false);
window.matchMedia?.('(prefers-color-scheme: dark)').addEventListener?.('change', (e) => {
  systemDark.value = e.matches;
});

const isDark = computed(() => (mode.value === 'system' ? systemDark.value : mode.value === 'dark'));

watchEffect(() => {
  document.documentElement.dataset.theme = isDark.value ? 'dark' : 'light';
});

/** Light/dark rejim — tokens.css `data-theme` + Naive `darkTheme` */
export function useTheme() {
  function toggle(): void {
    mode.value = isDark.value ? 'light' : 'dark';
    try {
      localStorage.setItem(STORAGE_KEY, mode.value);
    } catch {
      /* localStorage bo'lmasa ham ishlayveradi */
    }
  }
  return { mode, isDark, toggle };
}
